import * as React from 'react';
import { connect } from 'react-redux';

import styles from './userInfoComponents.module.scss';
import { bindActionCreators, Dispatch } from 'redux';

import { useTranslation } from 'react-i18next';
import { loginActions } from '../../../../store/login/actions';
import { RootState } from '../../../../store';
import { tr } from '../../../../utils/translations/translator';
import { userInfoMethods } from '../../stages/UserInfo';
import { useSignUpForm } from '../../__hooks__/useSignUpForm';
import store from '../../../../store/store';
import { StoreType } from '../../interfaces/store_types';
import { SignupCredentialsNotice } from '../../../Signup/SignupCredentialsNotice';

interface DispatchProps {
  actions: {
    signupRequest: (email: string, password: string) => void;
  };
}

interface OwnProps {
  selectedMethod: userInfoMethods | undefined;
  setSelectedMethod: (method: userInfoMethods) => void;
  storeType: StoreType;
  onGoToLogin: (email: string) => void;
}
type LoginProps = OwnProps & DispatchProps;

export const ShopSignup: React.FC<LoginProps> = ({
  actions,
  selectedMethod,
  setSelectedMethod,
  storeType,
  onGoToLogin,
}) => {
  const { t } = useTranslation();
  const isOpen = React.useMemo(
    () => (selectedMethod === 'SIGNUP' ? true : false),
    [selectedMethod],
  );
  const {
    states: { email, setEmail, setPassword, checked, setChecked },
    isSignUpBottomDisabled,
    showCredentialsError,
    handleSignUpSubmit,
  } = useSignUpForm();

  return (
    <div
      className={styles.container}
      onClick={() => setSelectedMethod('SIGNUP')}
    >
      <p>{tr(t, 'signup')}</p>

      <div className={styles.selectBtn}>
        <button
          className={isOpen ? styles.selected : styles.unselected}
        ></button>
      </div>

      {isOpen && (
        <form className={styles.form} onSubmit={handleSignUpSubmit}>
          <div className={styles.inputsContainer}>
            <input
              className={styles.input}
              type="text"
              placeholder={tr(t, 'email')}
              onChange={({ target: { value } }) => setEmail(value)}
            />

            <input
              className={styles.input}
              type="password"
              min={6}
              placeholder={tr(t, 'password')}
              onChange={({ target: { value } }) => setPassword(value)}
            />
          </div>

          <div className={styles.termsAndConditions}>
            <div
              className={`${styles.checkbox} ${
                checked ? `${styles.checked}` : ''
              }`}
              onClick={() => setChecked(!checked)}
            >
              {checked ? '✓' : ''}
            </div>
            <div>
              {t('accept-the')}{' '}
              <a href="/terms" className={styles.termsRef}>
                {t('terms-and-conditions')}
              </a>
            </div>
          </div>

          {showCredentialsError && (
            <SignupCredentialsNotice
              email={email}
              onLogin={() => onGoToLogin(email)}
            />
          )}

          <div className={styles.signupBtnWrapper} id={styles[storeType]}>
            <button
              type={'submit'}
              disabled={isSignUpBottomDisabled}
              id={styles.signupBtn}
            >
              {tr(t, 'proceed-to-payment')}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  //   user: userSelector(state),
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators(
    {
      signupRequest: loginActions.signupRequestAction,
    },
    dispatch,
  ),
});

export const ShopSignupConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ShopSignup);
